<div class="app login">
  <div class="grid-container" style="margin:auto">
    <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-4" style="margin:auto">
      <Form>
        {#if error}
          <div class="error">
            {error}
          </div>
        {/if}
        <div class="logo">
          <img src="https://events.thehoneycombproject.org/static/honeycomb/logo_small.png" />
        </div>
        <div class="form-group">
          <TextInput label="Email" bind:value={email} />
        </div>
        <div class="form-group">
          <PasswordInput label="Password" type="password" bind:value={password} />
        </div>
        <div on:click="{e => login()}" class="button primary full">LOGIN</div>
      </Form>
      
    </div>
    </div>
  </div>
</div>

<style>
  .login {
    margin-top: 100px;
  }

  .logo {
    margin: 1rem 0;
    text-align: center;
  }

  .error{
    background: #f7f7f8;
    padding: 8px;
    text-align: center;
    color: #f15656;
    font-weight: 600;
    font-family: proxima-nova, sans-serif;
  }
</style>

<script>
import {setContext, getContext} from 'svelte';

import {client} from '../../apollo/client';


import {session} from '../../utils/session.store';
import TextInput from '../../components/inputs/text';
import PasswordInput from '../../components/inputs/password';
import Form from '../../components/inputs/form';
import gql from 'graphql-tag';
import store from 'store';

let email;
let error;
let password;
let loggedIn = false;

const LOGIN = gql`
  mutation($input: LoginInput!) {
    login(input: $input) {
      id
      token
      role
    }
  }
`

const unsubscribe = session.subscribe(value => {
  loggedIn = value.loggedIn;
});

async function login() {
  try {
    const {data} = await client.mutate({mutation: LOGIN, variables: {
      input: {
        email,
        password
      }
    }})
    
    if(data.login.id && data.login.role === 'Admin') {
      store.set('token', data.login.token);
      session.update((s)=> {
        return {loggedIn: true, token: data.login.token}
      })
      
    }

  } catch (e) {
    error = 'Wrong username or password'
  }
}

</script>

